export default __webpack_public_path__ + "static/media/pageinfo.f814cddc.jpg";